import { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { HeaderWeb, Loading } from "senac-components";
import { useAppDispatch } from "../store";
import { authenticateSsoFromProvision } from "../store/reducers/userSlice";
import { AuthSSOParams } from "../services/user/IUserService";

export const WssoV2 = () => {
  const { connector, valueType, value, state } = useParams();
  const query_params = useLocation();
  const dispatch = useAppDispatch();
  const ran = useRef(false);

  useEffect(() => {

    const queryParams = new URLSearchParams(query_params.search);
    const path = queryParams.get("path") ?? "";

    if (!connector || !valueType || !value || !state) return;

    let data:AuthSSOParams = { connector, state, path: path };
    data[valueType as keyof AuthSSOParams] = value;

    dispatch(authenticateSsoFromProvision(data));
  }, []);

  return (
    <>
      <Loading show={true} />
    </>
  );
};
